import { FC, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
// import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { useMethods } from '@lhb/hook';
import ApprovalCreateDialog from '@/common/components/business/ExpandStore/ApprovalCreateDialog';
import { ApprovalType, ApprovalTypeValue, ChanceDetailModule } from '@/common/components/business/ExpandStore/ts-config';
import { formDataComsToTiled, getSubmitValuesByTiledFormData } from '@/common/components/business/DynamicComponent/config';
// import { checkApprovalForm } from '@/common/api/expandStore/expansiontask';
import { getChancePointDetail } from '@/common/api/expandStore/chancepoint';
import { isArray, isNotEmptyAny } from '@lhb/func';

/**
 * @Description 拓店任务-机会点-发起机会点审批的弹框
 *
 * 参照机会点详情中的提交审批处理实现
 *  src/common/components/business/ExpandStore/ChanceDetailDrawer/components/Title.tsx
 *  handleSubmitApproval()
 */
const CreateChanceApproval : FC<{
  ref?: any
  handleApprovalCreated: Function; // 审批发起后回调
}> = forwardRef(({
  handleApprovalCreated,
}, ref) => {
  useImperativeHandle(ref, () => ({
    create: methods.create
  }));

  const [id, setId] = useState<any>(null); // 机会点id
  const [chanceDetail, setChanceDetail] = useState<any>({}); // 机会点详情
  const [approvalVisible, setApprovalVisible] = useState<boolean>(false);
  const [approvalPropertyValues, setApprovalPropertyValues] = useState<any>([]);

  useEffect(() => {
    if (!isNotEmptyAny(chanceDetail)) return;

    const propertyValues = methods.parseChanceDetailToPropertyValues();
    if (!isArray(propertyValues) || !propertyValues.length) {
      setApprovalPropertyValues([]);
      setApprovalVisible(false);
    } else {
      setApprovalPropertyValues(propertyValues);
      setApprovalVisible(true);
    }
  }, [chanceDetail]);

  const methods = useMethods({
    /**
     * @description 发起机会点审批，
     *  处理步骤 1、检查表单 2、获取详情构建提交审批用参数 3、展示提交弹框
     * @param chanceId 机会点
     * @return
     */
    async create(chanceId: number) {
      setId(chanceId);

      /** 后端未能实现按照机会点审批流检查字段必填，暂时由前端去掉检查请求 */
      // const checkRes = await checkApprovalForm({
      //   type: ApprovalType.ChancePoint,
      //   typeValue: ApprovalTypeValue.ChancePointEvaluate,
      //   relationId: chanceId
      // });
      // if (!checkRes) {
      //   // 必填校验未通过
      //   V2Message.warning('机会点必填字段不能为空');
      //   return;
      // }
      const res = await getChancePointDetail({ id: chanceId });
      // 机会点详情
      setChanceDetail(res);
    },

    /**
     * @description 通过机会点详情获取propertyvalues
     */
    parseChanceDetailToPropertyValues() {
      const { moduleDetails } = chanceDetail;
      const module = isArray(moduleDetails) ? moduleDetails.find((itm: any) => itm.moduleType === ChanceDetailModule.Detail) : null;
      if (!module || !isNotEmptyAny(module.infoModule)) return null;

      const { propertyGroupVOList } = module.infoModule;
      if (!isArray(propertyGroupVOList) || !propertyGroupVOList.length) return null;

      const allComs: any = [];
      formDataComsToTiled(propertyGroupVOList, allComs); // 将组件对象平铺到数组中

      const propertyValues = getSubmitValuesByTiledFormData(allComs);
      return propertyValues;
    },

    /**
     * @description 提交审批成功
     */
    onComplete() {
      handleApprovalCreated?.();
    }
  });

  return (
    <ApprovalCreateDialog
      visible={approvalVisible}
      setVisible={setApprovalVisible}
      id={id}
      type={ApprovalType.ChancePoint}
      typeValue={ApprovalTypeValue.ChancePointEvaluate}
      specialParams={{
        propertyValues: approvalPropertyValues
      }}
      onComplete={methods.onComplete}/>
  );
});
export default CreateChanceApproval;
